import { useState, useEffect } from 'react';
import { mediaCompactHome } from '../config/homePageCountriesSheetBehavior';

/** True when viewport width ≤ 1024px (mobile + tablet). */
export function useCompactViewport() {
  const query = mediaCompactHome();
  const [isCompact, setIsCompact] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setIsCompact(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return isCompact;
}
